<template>
<div>
  <div class="container">
    <form class="form-horizontal" @submit.prevent="submitLogin">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <h2>ログイン</h2>
          <hr>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <div class="form-group has-danger">
            <label class="sr-only" for="username">Username</label>
            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
              <div class="input-group-addon" style="width: 2.6rem">
                <i class="fa fa-user-circle"></i>
              </div>
              <input type="text" name="username" class="form-control"
                v-model="loginForm.username" required autofocus>
            </div>
          </div>
        </div>
        <div class="col-md-3">
        </div>
      </div>
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="sr-only" for="password">Password</label>
            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
              <div class="input-group-addon" style="width: 2.6rem">
                <i class="fa fa-key"></i>
              </div>
              <input type="password" class="form-control" name="password"
                 v-model="loginForm.password" required>
            </div>
          </div>
        </div>
        <div class="col-md-3">
        </div>
      </div>
      <div class="row" style="padding-top: 1rem">
        <div class="col-md-3"></div>
        <div class="col-md-6 ta-center">
          <div class="form-control-feedback mb8" v-if="showErrorMessage">
            <span class="text-danger align-middle">
              <i class="fa fa-close"></i> ログインIDまたはパスワードが間違っています
            </span>
          </div>
          <button type="submit" class="btn btn-success">
            <i class="fa fa-sign-in"></i> ログイン
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      showErrorMessage: false,
    }
  },
  mounted() {
    this.$store.dispatch('user/getMe')
      .then(() => {
        // redirect to mypage default if already logged in
        this.$router.replace({ name: 'shutokou-kiloposts' })
      })
      .catch(() => {
        // nothing to do
      })
  },
  methods: {
    submitLogin() {
      this.showErrorMessage = false
      this.$store.dispatch('user/login', this.loginForm)
        .then(data => {
          // save api key
          this.$store.dispatch(
            'localStorage/set',
            { key: 'apiKey', val: data.api_key }
          )
          location.href = '/' // want to explicitly reload
        })
        .catch(e => {
          this.showErrorMessage = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 80px auto 0;
}
</style>
